import {
  DateField,
  DateFieldG4pProps,
  DateFieldProps,
} from "@dbn/omnichannel-design-system-g4p";
import { useFormatMessage, useI18nDateLabels } from "../../intl";
import { useAppContext } from "../../useAppContext";

export const DateFieldComp = (props: DateFieldProps | DateFieldG4pProps) => {
  const { i18nDatePicker } = useI18nDateLabels();
  const { locale } = useAppContext();
  const formatMessage = useFormatMessage();

  return (
    <DateField
      closeCalendarAriaLabel={formatMessage(
        "generic.dateField.mobileCalendarCloseButton.ariaLabel"
      )}
      {...props}
      locale={locale}
      i18n={i18nDatePicker}
      monthAriaLabel={i18nDatePicker.selectMonth}
      yearAriaLabel={i18nDatePicker.selectYear}
    />
  );
};
